import { push } from '@lagunovsky/redux-react-router'
import HomeAction from 'home/actions/HomeAction'
import { isUndefined, orderBy } from 'lodash'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import { hasValue } from 'utils/NumberUtil'
import { H_MAT_SIM } from '../../../../account/constants/AccessRulesConstants'
import { PATH_MATERIEL_SIM } from '../../../../home/constants/RouteConstants'
import DtoHydrometricStation from '../../../../hydrometry/dto/DtoHydrometricStation'
import DtoInstallation from '../../../../installation/dto/installation/DtoInstallation'
import DtoPiezometerLight from '../../../../piezometry/dto/DtoPiezometerLight'
import PluviometerDto from '../../../../pluviometry/dto/PluviometerDto'
import DtoQualitometerLight from '../../../../quality/dto/DtoQualitometerLight'
import CityDto from '../../../../referencial/components/city/dto/CityDto'
import ContributorDto from '../../../../referencial/components/contributor/dto/ContributorDto'
import ReferencialAppList from '../../../../referencial/components/ReferencialAppList'
import { getDate } from '../../../../utils/DateUtil'
import { componentHasHabilitations } from '../../../../utils/HabilitationUtil'
import { createIconMaterialState, getAssignmentLabel } from '../../../../utils/MaterielUtils'
import MaterielAssignmentLink from '../../MaterielAssignmentLink'
import { getLabel } from '../../../../utils/StoreUtils'
import { searchAllCharacters } from '../../../../utils/StringUtil'
import { LIST_PANEL, MAP_PANEL, MAT_HEADERS_SIM } from '../../../constants/MaterielConstants'
import DtoMaterielState from '../../../dto/DtoMaterielState'
import SimSubscriptionFilterForm from '../../filterPanel/SimSubscriptionFilterForm'
import MaterielsMapComponent from '../../map/MaterielsMapComponent'
import SimAction from '../../sim/actions/SimAction'
import DtoSimSituation from '../dto/DtoSimSituation'
import DtoSimType from '../dto/DtoSimType'
import SimDto from '../dto/SimDto'
import { Grid } from '@mui/material'

class SimsApp extends Component {
    constructor(props) {
        super(props)
        this.state = {
            view: LIST_PANEL,
            filter: this.getFilter(),
        }
    }

    getFilter = () => {
        const { globalResearch, location } = this.props
        const matType = queryString.parse(location.search)?.idType
        return {
            matType: isUndefined(matType) ? undefined : parseInt(matType),
            searchValue: globalResearch,
        }
    }

    componentDidMount() {
        if (!componentHasHabilitations(H_MAT_SIM)) { // A modifier quand react-router sera à jour
            this.props.push('/unauthorized')
            return
        }
        this.props.setHelpLink('materiel', '')
        if (!this.props.sims.length) {
            this.props.fetchSims(true)
        }
        if (!this.props.simTypes.length) {
            this.props.fetchSimTypes()
        }
        this.props.updateGlobalResearch('')
    }

    getHash = mat => searchAllCharacters(MAT_HEADERS_SIM.map(key => mat[key]).join(''))

    getFilterMateriels = materiels => {
        const {
            // filter,
            network,
            state,
            administrator,
            provider,
            matType,
            displayEquipment,
            searchValue,
            displayOutOfService,
        } = this.state.filter
        const filterEquipment = !displayEquipment ? materiels.filter(({ isEquipment }) => !isEquipment) : materiels
        const filterAdministrator = administrator ? filterEquipment.filter(({ administratorId }) => administrator === administratorId) : filterEquipment
        const filterProvider = provider ? filterAdministrator.filter(({ providerId }) => provider === providerId) : filterAdministrator
        const filterStatusCode = hasValue(state) ? filterProvider.filter(({ statusCode }) => statusCode === state) : filterProvider
        const filterType = matType ? filterStatusCode.filter(({ materielType }) => materielType === matType) : filterStatusCode
        const filterNetwork = network ? filterType.filter(({ networkCode }) => network === networkCode) : filterType
        const filterOutOfService = displayOutOfService ? filterNetwork : filterNetwork.filter(({ statusCode }) => statusCode !== 0 && statusCode !== 5 && statusCode !== 6)
        const searchValueFormated = searchAllCharacters(searchValue)
        return searchValue ? filterOutOfService.filter(mat => this.getHash(mat).includes(searchValueFormated)) : filterOutOfService
    }

    getExportData = (materiels) => {
        if (!materiels.length) {
            return []
        }
        const [head, ...tail] = materiels
        return [{ ...head, headers: MAT_HEADERS_SIM }, ...tail]
    }

    getPanel = sims => {
        if (this.state.view === MAP_PANEL) {
            return (
                <MaterielsMapComponent
                    materielLink={PATH_MATERIEL_SIM}
                    materiels={sims}
                />
            )
        }
        const formattedSims = sims.map(mat => ({
            ...mat,
            state: createIconMaterialState(mat.state, mat.statusCode),
            assignment: <MaterielAssignmentLink materiel={mat} />,
            nullValue: mat.isEquipment && <i className='material-icons' style={{ fontSize: '1.5rem' }}>devices_other</i>,
        }))
        return (
            <ReferencialAppList
                title={ i18n.sims }
                data={ formattedSims }
                exportData={ this.getExportData(sims) }
                type={{ headers: ['nullValue', ...MAT_HEADERS_SIM] }}
                newAction={ () => this.props.push('/materiel/sim/new') }
                showNewButton={ true }
                showPurgeButton={ false }
                setTitleAction={HomeAction.setTitle([{
                    title: i18n.materiel,
                    href: 'materiel',
                }, {
                    title: i18n.sims,
                    href: 'materiel/sim',
                }])}
                onClick={({ materielId }) => this.props.push(`/materiel/sim/${materielId}`)}
                searchable={false}
            />
        )
    }

    onChangeView = view => {
        this.setState({ view })
    }

    onValidate = filter => {
        this.setState({ filter })
    }

    getCorrespondingSite = ({ siteType, siteCode }) => {
        switch (siteType) {
            case 1:
                return this.props.piezometers.find(({ id }) => id === siteCode)
            case 2:
                return this.props.pluviometers.find(({ id }) => id === siteCode)
            case 3:
                return this.props.qualitometers.find(({ id }) => id === siteCode)
            case 4:
                return this.props.hydrometricStations.find(({ id }) => id === siteCode)
            case 7:
                return this.props.installations.find(({ id }) => id === siteCode)
            default:
                return {}
        }
    }

    getSimType = () => this.props.simTypes.filter(({ id, label }) => !!this.props.sims.find(({ simType }) => simType === id) && label).map(t => ({
        id: t.id,
        label: t.label,
    }))

    render() {
        const materiels = this.props.sims.map(mat => {
            const lastSituation = this.props.simsLastSituations.find(s => s.idSim === mat.id)
            const labelState = lastSituation ? getLabel(this.props.materielStates, lastSituation.statusCode) : ''
            const site = lastSituation && lastSituation.statusCode === 1 && lastSituation.siteType && lastSituation.siteCode && this.getCorrespondingSite(lastSituation) || {}
            const labelAssignment = (lastSituation && lastSituation.statusCode === 1 && getAssignmentLabel(site, lastSituation.siteName)) || ''
            const city = site.townCode && this.props.cities.find((o) => o.code === site.townCode) || undefined
            const cityLabel = city ? `${city.name} - [${city.code}]` : (site.townCode || '')
            const departmentLabel = city && city.departmentNumber ? city.departmentNumber : ''
            return {
                materielId: mat.id,
                type: getLabel(this.props.simTypes, mat.materielType),
                provider: getLabel(this.props.contributors, mat.providerId, 'labelDisplay', 'id'),
                state: labelState,
                statusCode: lastSituation && lastSituation.statusCode,
                stateDate: lastSituation && getDate(lastSituation.situationDate),
                city: cityLabel,
                administratorId: mat.administrator,
                serialNumberIccid: mat.serialNumber,
                assignment: labelAssignment,
                siteType: lastSituation && lastSituation.siteType,
                departmentShort: departmentLabel,
                purchaseDate: getDate(mat.purchaseDate),
                providerId: mat.providerId,
                networkCode: mat.networkCode,
                materielType: mat.materielType,
                isEquipment: mat.isEquipment,
                siteCode: lastSituation && lastSituation.siteCode,
                administrator: getLabel(this.props.contributors, mat.administrator, 'labelDisplay', 'code'),
            }
        })
        const filteredMateriels = this.getFilterMateriels(materiels)
        return (
            <Grid container spacing={1}>
                <Grid size={12}>
                    <SimSubscriptionFilterForm
                        view={this.state.view}
                        filter={this.state.filter}
                        changeView={this.onChangeView}
                        materiels={materiels}
                        typeList={orderBy(this.getSimType(), 'label')}
                        onValidate={ this.onValidate }
                        materielType='SIM'
                    />
                </Grid>
                <Grid size={12}>
                    {this.getPanel(filteredMateriels)}
                </Grid>
            </Grid>
        )
    }
}

SimsApp.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.object,
    }),
    allowModifications: PropTypes.bool,
    getLink: PropTypes.func,
    sims: PropTypes.arrayOf(PropTypes.instanceOf(SimDto)),
    simsLastSituations: PropTypes.arrayOf(PropTypes.instanceOf(DtoSimSituation)),
    simTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSimType)),
    cities: PropTypes.arrayOf(PropTypes.instanceOf(CityDto)),
    materielStates: PropTypes.arrayOf(PropTypes.instanceOf(DtoMaterielState)),
    piezometers: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometerLight)),
    pluviometers: PropTypes.arrayOf(PropTypes.instanceOf(PluviometerDto)),
    qualitometers: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualitometerLight)),
    hydrometricStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoHydrometricStation)),
    installations: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallation)),
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    push: PropTypes.func,
    fetchSims: PropTypes.func,
    fetchSimTypes: PropTypes.func,
    fetchMaterielStates: PropTypes.func,
    fetchContributors: PropTypes.func,
    fetchCities: PropTypes.func,
    globalResearch: PropTypes.string,
    updateGlobalResearch: PropTypes.func,
    setHelpLink: PropTypes.func,
}

const mapStateToProps = store => ({
    sims: store.SimReducer.sims,
    simsLastSituations: store.SimReducer.simsLastSituations,
    simTypes: store.SimReducer.simTypes,
    piezometers: store.PiezometryReducer.piezometersLight,
    pluviometers: store.PluviometryReducer.pluviometers,
    qualitometers: store.QualityReducer.qualitometersLight,
    hydrometricStations: store.HydrometryReducer.hydrometricStations,
    installations: store.InstallationReducer.installations,
    materielStates: store.MaterielReducer.materielStates,
    cities: store.CityReducer.cities,
    contributors: store.ContributorReducer.contributors,
    globalResearch: store.HomeReducer.globalResearch,
})

const mapDispatchToProps = {
    push,
    fetchSims: SimAction.fetchSims,
    updateGlobalResearch: HomeAction.updateGlobalResearch,
    fetchSimTypes: SimAction.fetchSimTypes,
    setHelpLink: HomeAction.setHelpLink,
}

export default connect(mapStateToProps, mapDispatchToProps)(SimsApp)
